<template>
    <el-dialog title="专辑分享" append-to-body :visible="visible" width="900px" @open="setQRCode" :before-close="handleClose">
        <div class="share-image">
            <div class="html2canvas" ref="html2canvas">
                <div class="image" :style="`background-color: ${themeColor};`">
                    <el-image :src="$utils.coverImg(album.cover, 500, 500)" fit="cover">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <span class="icon"></span>
                    <h3>{{ album.name }}</h3>
                    <p class="name">{{ `{ ${album.artist} }` }}</p>
                    <p class="slogan">“这个世界需要你的音乐。”</p>
                    <div class="ft" :style="`background-color: ${themeColor};`">
                        <img class="logos" src="@/assets/img/share-logo.png" />
                        <div class="qrcode-view">
                            <div class="qrcode" ref="qrCode"></div>
                            <p>扫码播放</p>
                        </div>
                    </div>
                    <!-- <div class="text">
                        SHOWSTART
                        <span>× RELEASE</span>
                    </div> -->
                </div>
            </div>
            <el-button @click="createImage" type="primary">下载到本地分享</el-button>
        </div>
    </el-dialog>
</template>

<script>
import QRCode from 'qrcodejs2';
import html2canvas from 'html2canvas';
import ls from 'local-storage';
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        album: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            url: '',
            qrcode: null,
            themeColor: 'rgb(248,248,248)',
        };
    },
    computed: {},
    watch: {},
    methods: {
        getImageColor(url) {
            if (!url) return '';
            const self = this;
            // 创建一个新的Image对象
            var image = new Image();
            image.crossOrigin = 'Anonymous';
            // 设置图片源
            image.src = this.$utils.coverImg(url);
            // 等待图片加载完成
            image.onload = function () {
                const imgHeight = 100;
                const imgWidth = 100;
                // 创建一个Canvas元素
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                // 将图片绘制到Canvas上
                context.drawImage(image, 0, 0, imgWidth, imgHeight);
                // 获取Canvas上指定坐标的像素数据
                var data = context.getImageData(0, 0, imgWidth, imgHeight).data;
                let arr = [];
                var r = 1,
                    g = 1,
                    b = 1;
                // 取所有像素的平均值
                for (var row = 0; row < imgHeight; row++) {
                    for (var col = 0; col < imgWidth; col++) {
                        if (row == 0) {
                            r += data[imgWidth * row + col];
                            g += data[imgWidth * row + col + 1];
                            b += data[imgWidth * row + col + 2];
                            arr.push([r, g, b]);
                        } else {
                            r += data[(imgWidth * row + col) * 4];
                            g += data[(imgWidth * row + col) * 4 + 1];
                            b += data[(imgWidth * row + col) * 4 + 2];
                            arr.push([r, g, b]);
                        }
                    }
                }
                // 求取平均值
                r /= imgWidth * imgHeight;
                g /= imgWidth * imgHeight;
                b /= imgWidth * imgHeight;
                // 将最终的值取整
                r = Math.round(r);
                g = Math.round(g);
                b = Math.round(b);
                self.themeColor = 'rgb(' + r + ',' + g + ',' + b + ')';
            };
        },
        setQRCode() {
            this.$nextTick(() => {
                // 兼容 /manage/album/share/:albumId 与 /pages/shareAlbum/shareAlbum?id=xxx 两种入口
                const albumId = this.$route.params.albumId || this.$route.query.id;
                let { invitationCode } = this.$route.query;
                if (!invitationCode) invitationCode = ls.get('invitationCode');
                invitationCode = invitationCode ? `&invitationCode=${invitationCode}` : '';
                if (this.qrcode) {
                    this.qrcode.makeCode(
                        `${this.$store.state.config.cpHomeUrl}/pages/shareAlbum/shareAlbum?id=${albumId}${invitationCode}`
                    );
                } else {
                    this.qrcode = new QRCode(this.$refs.qrCode, {
                        text: `${this.$store.state.config.cpHomeUrl}/pages/shareAlbum/shareAlbum?id=${albumId}${invitationCode}`,
                        width: 100,
                        height: 100,
                        colorLight: '#ffffff',
                        correctLevel: 3,
                    });
                }
            });
            this.getImageColor(this.album.cover);
        },
        handleClose() {
            this.$emit('update:visible', false);
        },
        createImage() {
            html2canvas(this.$refs.html2canvas, {
                width: 750,
                height: 1280,
                useCORS: true,
                x: 55,
                scale: 2,
            }).then((canvas) => {
                const url = canvas.toDataURL('image/png');
                const a = document.createElement('a');
                a.href = url;
                a.setAttribute('download', 'share');
                a.click();
            });
        },
    },
};
</script>
<style lang="scss">
.share-image {
    text-align: center;

    .image {
        width: 750px;
        height: 1280px;
        margin: 0 auto 60px;
        position: relative;
        text-align: left;
        overflow: hidden;

        &::before {
            content: '';
            width: 100%;
            height: 100%;
            background: url('~@/assets/img/share-bg.png') no-repeat center;
            background-size: cover;
            position: absolute;
            top: 0px;
            left: 0px;
            z-index: 0;
        }

        .ft {
            height: 220px;
            position: absolute;
            bottom: 0px;
            width: 100%;
            left: 0px;

            .logos {
                width: 516px;
                padding: 50px 30px;
            }

            .qrcode-view {
                width: 108px;
                height: 140px;
                background: #ffffff;
                text-align: center;
                position: absolute;
                bottom: 40px;
                right: 30px;
                padding: 4px;
                z-index: 1;

                .qrcode {
                    width: 100px;
                    height: 100px;
                }

                p {
                    font-size: 16px;
                    font-weight: 400;
                    color: #000000;
                    line-height: 16px;
                    letter-spacing: 4px;
                    margin-top: 6px;
                }
            }
        }

        .el-image {
            top: 340px;
            position: absolute;
            left: 0px;
            z-index: 2;
            width: 500px;
            height: 500px;
        }

        .icon {
            position: absolute;
            left: 458px;
            background: url('~@/assets/img/share-icon.png') no-repeat center;
            background-size: cover;
            top: 360px;
            width: 232px;
            height: 460px;
            z-index: 1;
        }

        h3 {
            font-size: 60px;
            font-weight: 600;
            color: #000;
            line-height: 60px;
            position: absolute;
            z-index: 1;
            left: 40px;
            right: 40px;
            bottom: 1064px;
        }

        p.name {
            font-size: 24px;
            font-weight: 400;
            color: #666;
            line-height: 24px;
            position: absolute;
            left: 40px;
            right: 40px;
            bottom: 1000px;
            z-index: 1;
        }

        .slogan {
            font-size: 24px;
            font-weight: 400;
            color: #000000;
            line-height: 24px;
            position: absolute;
            bottom: 356px;
            left: 40px;
            right: 40px;
        }
    }
}
</style>
